module.exports = __webpack_public_path__ + "static/img/index.a0d37b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/vubrostand/LVT/index.png
// module id = 9eWf
// module chunks = 0